import { makeAutoObservable, runInAction } from 'mobx'
import { LoadCurrentUserTask } from '../Tasks/LoadCurrentUserTask'

/**
 * Local store of `UserProfilePage` — `/profile`.
 * Owns the currently authenticated user payload and the in-flight flag.
 */
export class UserProfileStore {
    userData: any = null
    loading = true

    constructor() {
        makeAutoObservable(this)
    }

    async load(): Promise<void> {
        this.loading = true
        try {
            const data = await LoadCurrentUserTask()
            if (data) {
                runInAction(() => { this.userData = data })
            }
        } catch (error) {
            console.error('Error loading current user:', error)
        } finally {
            runInAction(() => { this.loading = false })
        }
    }

    /** Reload silently after the edit drawer closes; keeps `loading` false. */
    async reload(): Promise<void> {
        try {
            const data = await LoadCurrentUserTask()
            if (data) {
                runInAction(() => { this.userData = data })
            }
        } catch (error) {
            console.error('Error reloading current user:', error)
        }
    }
}
